import { Controller } from "@hotwired/stimulus"

// Shows and hides a panel from a button ("Change")
export default class extends Controller {
  static targets = ["panel"]

  toggle(event) {
    const hidden = this.panelTarget.classList.toggle("hidden")
    event.currentTarget.setAttribute("aria-expanded", String(!hidden))
    if (!hidden) this.panelTarget.querySelector("select, input")?.focus()
  }
}
